import Vue from 'vue';
import lang from '@/lang';

Vue.directive('translate', (el, { value }) => {
  // eslint-disable-next-line
  el.innerText = lang.translate(value);
});
